// import { nis2Services } from '../data/nis2Services';
import { env, validateEnv } from '../config/env';

const OPENAI_MODEL = "gpt-3.5-turbo";

// List of valid country codes for validation
// const VALID_COUNTRY_CODES = [
//   'AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR',
//   'DE', 'GR', 'HU', 'IE', 'IT', 'LV', 'LT', 'LU', 'MT', 'NL',
//   'PL', 'PT', 'RO', 'SK', 'SI', 'ES', 'SE', 'GB', 'IS', 'LI',
//   'NO', 'CH'
// ];

// Flatten NIS2 services for easier lookup
// const flatNis2Services = nis2Services.reduce((acc, category) => {
//   return [
//     ...acc,
//     ...category.services.map(service => ({
//       ...service,
//       category: category.category
//     }))
//   ];
// }, []);

// Common service name mappings to NIS2 service values
// const serviceNameMapping = {
//   // Energy sector
//   'electricity': 'electricity_supply',
//   'power generation': 'electricity_supply',
//   'power distribution': 'electricity_distribution',
//   'power transmission': 'electricity_transmission',
//   'oil': 'oil_production',
//   'petroleum': 'oil_production',
//   'gas': 'gas_supply',
//   'natural gas': 'gas_supply',
//   'gas distribution': 'gas_distribution',
//   'hydrogen': 'hydrogen_production',

//   // Transport sector
//   'air traffic': 'air_traffic',
//   'aviation': 'air_traffic',
//   'rail': 'rail_transport',
//   'railway': 'rail_transport',
//   'maritime': 'water_transport',
//   'shipping': 'water_transport',
//   'road': 'road_transport',
//   'highway': 'road_transport',
//   'logistics': 'logistics',
//   'supply chain': 'logistics',

//   // Banking sector
//   'bank': 'credit_institution',
//   'banking': 'credit_institution',
//   'trading': 'trading_venue',
//   'stock exchange': 'trading_venue',
//   'clearing': 'central_counterparty',
//   'clearinghouse': 'central_counterparty',

//   // Financial Infrastructure
//   'payment': 'payment_systems',
//   'payment processing': 'payment_systems',
//   'securities': 'securities_settlement',
//   'settlement': 'securities_settlement',

//   // Health sector
//   'hospital': 'healthcare_provider',
//   'clinic': 'healthcare_provider',
//   'medical device': 'medical_device_manufacturer',
//   'pharmaceutical': 'pharmaceutical_manufacturer',
//   'pharma': 'pharmaceutical_manufacturer',
//   'medical research': 'medical_research',
//   'clinical research': 'medical_research',

//   // Water sector
//   'water supply': 'water_supplier',
//   'water utility': 'water_supplier',
//   'water distribution': 'water_distribution',

//   // Digital Infrastructure
//   'dns': 'dns_provider',
//   'domain': 'dns_provider',
//   'tld': 'tld_registry',
//   'domain registry': 'tld_registry',
//   'telecom': 'telecom_provider',
//   'telecommunications': 'telecom_provider',
//   'cdn': 'cdn_provider',
//   'content delivery': 'cdn_provider',
//   'datacenter': 'data_center',
//   'data centre': 'data_center',
//   'cloud': 'cloud_provider',
//   'cloud computing': 'cloud_provider',
//   'msp': 'managed_service_provider',
//   'managed services': 'managed_service_provider',
//   'trust service': 'trust_service_provider',
//   'digital signature': 'trust_service_provider',

//   // Public Administration
//   'government': 'government_entity',
//   'public sector': 'government_entity',
//   'public service': 'public_service',

//   // Space sector
//   'space': 'space_operations',
//   'satellite': 'space_operations',
//   'earth observation': 'earth_observation',
//   'remote sensing': 'earth_observation',

//   // Waste Management
//   'waste': 'waste_management',
//   'recycling': 'waste_management',
//   'waste treatment': 'waste_treatment',

//   // Chemical sector
//   'chemical': 'chemical_manufacturing',
//   'chemicals': 'chemical_manufacturing',
//   'chemical distribution': 'chemical_distribution',

//   // Food sector
//   'food': 'food_production',
//   'food processing': 'food_production',
//   'food distribution': 'food_distribution',

//   // Manufacturing
//   'critical manufacturing': 'manufacturing_critical',
//   'essential manufacturing': 'manufacturing_essential',

//   // Digital Services
//   'marketplace': 'online_marketplace',
//   'e-commerce': 'online_marketplace',
//   'search engine': 'online_search_engine',
//   'social network': 'social_networking',
//   'social media': 'social_networking',
//   'platform': 'platform_service',
//   'data processing': 'data_processing',
//   'analytics': 'data_processing'
// };

// Helper function to find closest matching service


// Helper function to validate OpenAI API key
function isValidOpenAIKey(key) {
  if (!key) return false;
  // OpenAI keys typically start with 'sk-' and are 51 characters long
  return typeof key === 'string' && key.startsWith('sk-') && key.length > 40;
}

// Helper function to extract JSON from OpenAI response
function extractJSON(text) {
  try {
    // First try direct parsing
    return JSON.parse(text);
  } catch (e) {
    // If that fails, try to extract JSON from markdown
    const jsonMatch = text.match(/```(?:json)?\s*({[\s\S]*?})\s*```/);
    if (jsonMatch) {
      try {
        return JSON.parse(jsonMatch[1]);
      } catch (e2) {
        console.error('Failed to parse extracted JSON:', e2);
        throw new Error('Invalid JSON format in response');
      }
    }
    console.error('No JSON found in response');
    throw new Error('No valid JSON found in response');
  }
}

// Helper function for OpenAI API calls
async function callOpenAI(messages, retries = 2) {
  if (!validateEnv()) {
    throw new Error('Missing required environment variables. Please check your .env file.');
  }

  const apiKey = env.OPENAI_API_KEY;
  
  if (!isValidOpenAIKey(apiKey)) {
    console.error('Invalid OpenAI API Key format');
    throw new Error('Invalid OpenAI API key format. Please check your REACT_APP_OPENAI_API_KEY in .env file');
  }

  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${apiKey}`
    },
    body: JSON.stringify({
      model: OPENAI_MODEL,
      messages: messages,
      temperature: 0.3,
      max_tokens: 800,
      presence_penalty: 0.1,
      frequency_penalty: 0.1
    })
  };

  let lastError = null;
  for (let attempt = 0; attempt <= retries; attempt++) {
    try {
      if (attempt > 0) {
        console.log(`Retry attempt ${attempt}/${retries}`);
        await new Promise(resolve => setTimeout(resolve, 1000 * attempt));
      }

      const response = await fetch('https://api.openai.com/v1/chat/completions', requestOptions);
      const data = await response.json();

      if (!response.ok) {
        const errorMessage = data.error?.message || 'OpenAI API request failed';
        const error = new Error(
          response.status === 401 ? 'Invalid OpenAI API key. Please check your REACT_APP_OPENAI_API_KEY in .env file' :
          response.status === 429 ? 'OpenAI API rate limit reached. Please try again later' :
          errorMessage
        );
        error.status = response.status;
        error.data = data;
        throw error;
      }

      return data;
    } catch (error) {
      console.error(`API call attempt ${attempt + 1} failed:`, error);
      lastError = error;

      // Don't retry on certain errors
      if (error.status === 401 || // Invalid API key
          error.status === 404 || // Invalid endpoint
          error.status === 429) { // Rate limit
        throw error;
      }
    }
  }

  throw lastError;
}

async function getCompanyInfo(domain) {
  const messages = [
    {
      role: "system",
      content: `You are a helpful assistant that retrieves company information from domain names. 
      Provide accurate information in JSON format. Include as much detail as possible about the company.`
    },
    {
      role: "user",
      content: `Please analyze the domain ${domain} and provide the following information in JSON format:
{
  "legalName": "Full legal name of the company",
  "tradingName": "Trading or brand name if different from legal name",
  "registrationNumber": "Company registration number if available",
  "registrationCountry": "Two-letter ISO country code where the company is registered",
  "employeeCount": number of employees (numerical value only),
  "annualTurnover": annual turnover in EUR (numerical value only),
  "companySize": "one of: micro, small, medium, large",
  "primarySector": "Main business sector",
  "secondarySectors": ["Array of other sectors if applicable"],
  "servicesDescription": "Detailed description of main services and products",
  "operationalScope": "one of: local, regional, national, eu, international",
  "operatingCountries": ["Array of country codes where the company operates"],
  "mainOfficeLocation": "Main office or headquarters location",
  "description": "General company description"
}

Ensure all numerical values are numbers without currency symbols or text.
Use standardized values for companySize and operationalScope.
For country codes, use ISO 3166-1 alpha-2 format.
If a value is unknown, use null instead of leaving it empty.`
    }
  ];

  try {
    const response = await callOpenAI(messages);
    const content = response.choices[0].message.content;
    const jsonData = extractJSON(content);
    
    if (!jsonData) {
      throw new Error('Failed to parse company information');
    }

    // Ensure all fields exist with defaults
    const formattedData = {
      legalName: jsonData.legalName || '',
      tradingName: jsonData.tradingName || jsonData.legalName || '',
      registrationNumber: jsonData.registrationNumber || '',
      registrationCountry: jsonData.registrationCountry || '',
      employeeCount: parseInt(jsonData.employeeCount) || 0,
      annualTurnover: parseInt(jsonData.annualTurnover) || 0,
      companySize: jsonData.companySize || determineCompanySize(jsonData.employeeCount),
      primarySector: jsonData.primarySector?.toLowerCase() || 'other',
      secondarySectors: Array.isArray(jsonData.secondarySectors) ? jsonData.secondarySectors.join(', ') : '',
      servicesDescription: jsonData.servicesDescription || jsonData.description || '',
      operationalScope: jsonData.operationalScope || 'national',
      operatingCountries: Array.isArray(jsonData.operatingCountries) ? jsonData.operatingCountries.join(', ') : jsonData.registrationCountry || '',
      mainOfficeLocation: jsonData.mainOfficeLocation || jsonData.registrationCountry || '',
      confidence: 0.85,
      source: 'OpenAI'
    };

    console.log('Formatted company info:', formattedData);
    return formattedData;
  } catch (error) {
    console.error('Error getting company info:', error);
    throw error;
  }
}

async function analyzeCompanyServices(companyInfo) {
  const messages = [
    {
      role: "system",
      content: `You are a regulatory compliance expert specializing in NIS2, DORA, and GDPR regulations. 
      Analyze services to determine their regulatory obligations and provide detailed justifications.
      Always return analysis in the specified JSON format.`
    },
    {
      role: "user",
      content: `Analyze the following company and service for NIS2, DORA, and GDPR applicability:

Company Information:
- Name: ${companyInfo.company_name}
- Description: ${companyInfo.company_description}
- Service being analyzed: ${companyInfo.main_services[0]}

Provide a detailed analysis in the following JSON format:
{
  "service_name": "Name of the service",
  "service_description": "Brief description of what this service entails",
  
  "nis2_assessment": {
    "applicability": "yes|maybe|no",
    "justification": "Detailed explanation of why this service falls under NIS2 or not",
    "classification": "essential|important|not_applicable",
    "classification_reason": "Explanation of why this classification was chosen"
  },
  
  "dora_assessment": {
    "applicability": "yes|maybe|no",
    "justification": "Detailed explanation of why DORA applies or not",
    "classification": "direct|ict_provider|not_applicable",
    "classification_reason": "Explanation of the classification"
  },
  
  "gdpr_assessment": {
    "applicability": "yes|maybe|no",
    "justification": "Detailed explanation of GDPR applicability",
    "classification": "controller|processor|not_applicable",
    "classification_reason": "Explanation of the role classification"
  }
}

Consider:
- For NIS2: Focus on critical infrastructure, essential services, and digital service providers
- For DORA: Consider financial sector services and ICT service providers
- For GDPR: Analyze personal data processing activities and roles

Provide detailed justifications and cite specific aspects of the service that led to your conclusions.`
    }
  ];

  try {
    const response = await callOpenAI(messages);
    const content = response.choices[0].message.content;
    const jsonData = extractJSON(content);
    
    if (!jsonData) {
      throw new Error('Failed to parse service analysis');
    }

    // Add confidence scores and normalize the response
    const analysis = {
      service_name: jsonData.service_name,
      service_description: jsonData.service_description,
      
      nis2_assessment: {
        ...jsonData.nis2_assessment,
        confidence: 0.85,
        in_scope: jsonData.nis2_assessment.applicability === 'yes',
        maybe_in_scope: jsonData.nis2_assessment.applicability === 'maybe'
      },
      
      dora_assessment: {
        ...jsonData.dora_assessment,
        confidence: 0.85,
        in_scope: jsonData.dora_assessment.applicability === 'yes',
        maybe_in_scope: jsonData.dora_assessment.applicability === 'maybe'
      },
      
      gdpr_assessment: {
        ...jsonData.gdpr_assessment,
        confidence: 0.85,
        processes_data: jsonData.gdpr_assessment.applicability === 'yes',
        maybe_processes_data: jsonData.gdpr_assessment.applicability === 'maybe'
      }
    };

    console.log('Service analysis:', analysis);
    return [analysis]; // Return as array for backward compatibility
  } catch (error) {
    console.error('Error analyzing service:', error);
    throw error;
  }
}

async function extractCompanyServices(companyInfo) {
  const messages = [
    {
      role: "system",
      content: `You are an expert at analyzing company descriptions to identify their services and primary sector.
      Extract a list of services and determine the most likely primary sector from NIS2 categories.
      Always return in the specified JSON format.`
    },
    {
      role: "user",
      content: `Analyze this company information and extract their services and primary sector:

Company Name: ${companyInfo.company_name}
Company Description: ${companyInfo.company_description}

Return the analysis in this exact format:
{
  "services": [
    {
      "name": "Service Name",
      "description": "Brief description of what this service entails",
      "confidence": 0.0 to 1.0
    }
  ],
  "primary_sector": {
    "name": "One of: Energy, Transport, Banking, Financial Market Infrastructures, Health, Drinking Water, Waste Water, Digital Infrastructure, ICT Service Management, Public Administration, Space, Postal and Courier Services, Waste Management, Chemicals, Food, Manufacturing, Digital Providers, Research, Other",
    "confidence": 0.0 to 1.0,
    "justification": "Explanation of why this sector was chosen"
  }
}

Consider:
- Extract specific services the company provides
- Map to NIS2 sectors where possible
- Provide confidence scores for each extraction
- Include brief descriptions for clarity`
    }
  ];

  try {
    const response = await callOpenAI(messages);
    const content = response.choices[0].message.content;
    const jsonData = extractJSON(content);
    
    if (!jsonData || !jsonData.services || !jsonData.primary_sector) {
      throw new Error('Invalid service extraction format');
    }

    return {
      suggested_services: jsonData.services,
      primary_sector: jsonData.primary_sector
    };
  } catch (error) {
    console.error('Error extracting services:', error);
    throw error;
  }
}

async function analyzeCompanyData(companyInfo, services) {
  try {
    const prompt = {
      role: "system",
      content: `You are a regulatory compliance expert. Analyze the company data and determine:
1. NIS2 applicability status (not_applicable, gray_important, gray_essential, applicable_important, applicable_essential)
2. GDPR applicability status (not_applicable, processor, controller)
3. DORA applicability status (not_applicable, indirect, direct)

Return a JSON object with the following structure:
{
  "nis2": {
    "status": "string (one of the above values)",
    "confidence": "number (0-1)",
    "reasoning": "string"
  },
  "gdpr": {
    "status": "string (one of the above values)",
    "confidence": "number (0-1)",
    "reasoning": "string"
  },
  "dora": {
    "status": "string (one of the above values)",
    "confidence": "number (0-1)",
    "reasoning": "string"
  }
}`
    };

    // Format services for the prompt
    const servicesList = services.map(s => s.name).join(', ');

    const userPrompt = {
      role: "user",
      content: `Company Data:
- Name: ${companyInfo.company_name}
- Registration Country: ${companyInfo.registration_country}
- Services: ${servicesList}
- Annual Turnover: €${companyInfo.annual_turnover}
- Employee Count: ${companyInfo.employee_count}

Detailed Service Information:
${services.map(s => `
- ${s.name}:
  * NIS2: ${s.nis2_applicability} (${s.nis2_classification})
  * DORA: ${s.dora_applicability}
  * GDPR: ${s.gdpr_applicability}
`).join('\n')}
`
    };

    const data = await callOpenAI([prompt, userPrompt]);
    console.log('Company analysis response:', data);

    try {
      const content = data.choices[0].message.content;
      console.log('Raw response content:', content);
      
      const parsedContent = extractJSON(content);
      console.log('Parsed company analysis:', parsedContent);
      
      return parsedContent;
    } catch (parseError) {
      console.error('Error parsing company analysis:', parseError);
      throw new Error('Error parsing OpenAI response: ' + parseError.message);
    }
  } catch (error) {
    console.error('Error analyzing company data:', error);
    throw error;
  }
}

async function getCompanyDataFromDomain(domain) {
  try {
    // Get initial company info
    const companyInfo = await getCompanyInfo(domain);
    console.log('Initial company info:', companyInfo);
    
    // Get services analysis
    const services = await analyzeCompanyServices({
      company_name: companyInfo.legalName,
      company_description: companyInfo.servicesDescription,
      main_services: companyInfo.servicesDescription.split('. ').map(s => s.trim()) // Split description into services
    });
    
    // Get regulatory analysis
    const analysis = await analyzeCompanyData(
      {
        company_name: companyInfo.legalName,
        registration_country: companyInfo.registrationCountry,
        annual_turnover: companyInfo.annualTurnover,
        employee_count: companyInfo.employeeCount,
        company_description: companyInfo.servicesDescription
      }, 
      services
    );
    
    // Return combined data
    return {
      ...companyInfo, // This now contains all the form fields
      services,
      analysis,
      timestamp: new Date().toISOString()
    };
  } catch (error) {
    console.error('Error getting company data:', error);
    throw error;
  }
}

async function analyzeDomain(domain) {
  console.log('Starting domain analysis process for:', domain);
  
  try {
    // Get company data from domain
    const companyData = await getCompanyDataFromDomain(domain);
    console.log('Raw company data:', companyData);
    
    if (!companyData) {
      return {
        error: 'Could not retrieve company data',
        success: false
      };
    }

    // Format data for the form
    const formattedData = {
      // Basic Info
      legalName: companyData.legalName || '',
      tradingName: companyData.tradingName || '',
      registrationNumber: companyData.registrationNumber || '',
      registrationCountry: companyData.registrationCountry || '',

      // Size Info
      employeeCount: companyData.employeeCount || 0,
      annualTurnover: companyData.annualTurnover || 0,
      companySize: companyData.companySize || 'small',

      // Sector Info
      primarySector: companyData.primarySector || 'other',
      secondarySectors: companyData.secondarySectors || '',
      servicesDescription: companyData.servicesDescription || '',

      // Operations
      operationalScope: companyData.operationalScope || 'national',
      operatingCountries: companyData.operatingCountries || '',
      mainOfficeLocation: companyData.mainOfficeLocation || '',

      // Analysis results
      services: companyData.services || [],
      analysis: companyData.analysis || null,
      
      // Metadata
      confidence: companyData.confidence || 0.85,
      timestamp: companyData.timestamp || new Date().toISOString(),
      success: true
    };

    console.log('Formatted data for form:', formattedData);
    return formattedData;
    
  } catch (error) {
    console.error('Error in analyzeDomain:', error);
    return {
      error: error.message,
      success: false
    };
  }
}

async function generateCompanyDescription(companyName) {
  const messages = [
    {
      role: "system",
      content: `You are an expert at analyzing company names to generate concise, professional business descriptions.
      Generate a brief, factual description focusing on the company's likely business activities based on its name.
      Keep the description under 250 characters and focus on main business areas.`
    },
    {
      role: "user",
      content: `Generate a short, professional description for this company: "${companyName}"

Return the response in this JSON format:
{
  "description": "The generated description",
  "confidence": 0.0 to 1.0,
  "business_areas": ["Main business area 1", "Main business area 2"]
}

Guidelines:
- Keep it factual and professional
- Focus on likely main business activities
- Avoid speculative details
- Keep it under 250 characters`
    }
  ];

  try {
    const response = await callOpenAI(messages);
    const content = response.choices[0].message.content;
    const jsonData = extractJSON(content);
    
    if (!jsonData || !jsonData.description) {
      throw new Error('Invalid description generation format');
    }

    return jsonData;
  } catch (error) {
    console.error('Error generating company description:', error);
    throw error;
  }
}

async function generateComplianceSummary(companyData) {
  console.log('🚀 Starting compliance summary generation');
  
  if (!companyData) {
    console.error('❌ No company data provided');
    throw new Error('Company data is required');
  }

  // Validate required fields
  const requiredFields = ['legalName', 'companyDescription', 'registrationCountry', 'employeeCount'];
  const missingFields = requiredFields.filter(field => !companyData[field]);
  
  if (missingFields.length > 0) {
    console.error('❌ Missing required fields:', missingFields);
    throw new Error(`Missing required fields: ${missingFields.join(', ')}`);
  }

  console.log('📊 Processing company data:', {
    name: companyData.legalName,
    country: companyData.registrationCountry,
    size: companyData.employeeCount,
    servicesCount: Array.isArray(companyData.services) ? companyData.services.length : 0
  });

  // Prepare services data
  const services = Array.isArray(companyData.services) ? companyData.services : [];
  const servicesData = services.map(service => ({
    name: service.name || 'Unnamed Service',
    description: service.description || 'No description',
    analysis: service.analysis || {}
  }));

  // Create the system message
  const systemMessage = {
    role: "system",
    content: `You are a regulatory compliance expert specializing in NIS2, DORA, and GDPR regulations.
    Your task is to analyze the provided company information and generate a detailed compliance assessment.
    Focus on practical implications and clear justifications based on the company's characteristics and services.
    Provide specific references to relevant articles and requirements from each regulation.`
  };

  // Create the user message with company data
  const userMessage = {
    role: "user",
    content: `Analyze the regulatory obligations for this company:

Company Profile:
- Legal Name: ${companyData.legalName}
- Description: ${companyData.companyDescription}
- Country: ${companyData.registrationCountry}
- Employees: ${companyData.employeeCount}
- Size Category: ${companyData.companySize || determineCompanySize(companyData.employeeCount)}
- Primary Sector: ${companyData.primarySector || determinePrimarySector(services)}

Services:
${servicesData.map(s => `- ${s.name}: ${s.description}`).join('\\n')}

Previous Service Analysis:
${JSON.stringify(servicesData.map(s => s.analysis), null, 2)}

Generate a comprehensive regulatory analysis in this exact JSON format:
{
  "nis2_summary": {
    "relevance_explanation": "Why NIS2 is relevant to this organization",
    "applicability_type": "essential|important|not_applicable",
    "applicability_justification": "Detailed classification explanation with specific references",
    "key_implications": ["Key requirements and implications"]
  },
  "dora_summary": {
    "relevance_explanation": "Why DORA matters for this organization",
    "applicability_type": "direct|indirect|not_applicable",
    "applicability_justification": "Whether DORA applies directly or as ICT provider",
    "key_implications": ["Key requirements and implications"]
  },
  "gdpr_summary": {
    "relevance_explanation": "GDPR relevance to operations",
    "role_classification": "controller|processor|both|not_applicable",
    "role_justification": "Role classification explanation with assumptions",
    "key_implications": ["Key requirements and implications"]
  }
}`
  };

  try {
    console.log('🌐 Calling OpenAI API for compliance analysis...');
    const response = await callOpenAI([systemMessage, userMessage]);
    console.log('✅ Received OpenAI response');

    const content = response.choices[0].message.content;
    console.log('📄 Processing response content...');

    const jsonData = extractJSON(content);
    
    if (!jsonData) {
      console.error('❌ Failed to parse JSON from response');
      throw new Error('Failed to generate compliance summary: Invalid response format');
    }

    // Validate required sections
    const requiredSections = ['nis2_summary', 'dora_summary', 'gdpr_summary'];
    const missingSections = requiredSections.filter(section => !jsonData[section]);

    if (missingSections.length > 0) {
      console.error('❌ Missing required sections in response:', missingSections);
      throw new Error(`Invalid compliance summary: Missing sections: ${missingSections.join(', ')}`);
    }

    console.log('✨ Successfully generated compliance summary');
    return jsonData;
  } catch (error) {
    console.error('❌ Error in generateComplianceSummary:', error);
    throw error;
  }
}

// Helper function to determine company size based on employee count
function determineCompanySize(employeeCount) {
  if (!employeeCount) return 'unknown';
  if (employeeCount < 10) return 'micro';
  if (employeeCount < 50) return 'small';
  if (employeeCount < 250) return 'medium';
  return 'large';
}

// Helper function to determine primary sector from services
function determinePrimarySector(services) {
  if (!services || services.length === 0) return 'other';
  
  // Get the first service's NIS2 classification as primary sector
  const primaryService = services[0];
  if (!primaryService || !primaryService.nis2_classification) return 'other';

  // Map NIS2 classification to sector values
  const sectorMapping = {
    'energy': 'energy',
    'transport': 'transport',
    'banking': 'banking',
    'financial_market': 'financial',
    'healthcare': 'health',
    'drinking_water': 'drinking_water',
    'waste_water': 'waste_water',
    'digital_infrastructure': 'digital_infrastructure',
    'ict': 'ict',
    'public_administration': 'public_admin',
    'space': 'space',
    'postal': 'postal',
    'waste': 'waste_management',
    'chemicals': 'chemicals',
    'food': 'food',
    'manufacturing': 'manufacturing',
    'digital_provider': 'digital_providers',
    'research': 'research'
  };

  return sectorMapping[primaryService.nis2_classification.toLowerCase()] || 'other';
}

export { 
  getCompanyInfo, 
  analyzeCompanyServices, 
  analyzeDomain, 
  extractCompanyServices, 
  generateCompanyDescription,
  generateComplianceSummary 
};
